import React, { Component } from "react";
import {
  objectOf,
  bool,
  func,
  string,
  shape,
  number,
  object,
  arrayOf,
  oneOfType
} from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";
// import { Notifier } from "veritone-react-common";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle, DialogActions, DialogContent } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import Close from "@material-ui/icons/Close";
import Keyboard from "@material-ui/icons/Keyboard";
import cx from "classnames";
import { CSVLink } from "react-csv";
import moment from "moment";
import styles from "./styles.scss";
import Tooltip from "@material-ui/core/Tooltip";
import SummaryDrillDown from "./SummaryDrillDown"
import constants from "./constants";
import { moveBackReassignSaga } from "state/modules/app/campaign"
import { EXCLUDE, INCLUDE, REASSIGN, SHOW_TOAST_ACTIONS } from "../../../helpers/constant"
import { convertTimezoneDate, convertCalendarWithTimezone } from "../../../helpers/formatData";
import { DEFAULT_TIME_ZONE_KEY } from 'components/TimeZoneSelector/constants';
import KeyboardShortcutsModal from "../KeyboardShortcutsModal";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { advertiserShape } from "../../../helpers/propTypes";
import {
  AD_TYPE_ID,
  REASSIGNED,
  ADTYPE_CHART_ID,
  STATION_CHART_ID,
  ADVISIT_CHART_ID,
  GEO_CHART_ID,
  GA_CHART_ID,
  DAYPART_COMPILATION_CHART_ID,
  TRAFFIC_CHANNEL_CHART_ID
} from "../../../helpers/constant";
import {
  updateSummaryDrillDownSaga,
  changeDateRange,
  getDataDrillDownSaga,
  undoUpdateDrillDownSaga,
  updateDataDrillDown,
} from "../../../state/modules/app/campaign";
import { hideToastWithAction, showToastWithAction } from "../../../state/modules/app/notification";
import { detailUrlPropsType } from "./constants";

import { ROUTE_DRILLDOWN } from "../../../state/modules/routing";
import { goToCampaignPage } from 'state/modules/routing/actions';

const customStyle = theme => ({
  dialogShowAllAds: {
    display: 'flex',
    flexDirection: 'column'
  },
  dialogContent: {
    overflow: 'hidden',
    padding: '0px 24px 24px'
  },
  tableShowAllAds: {
    maxHeight: '76%',
    width: '90%',
    margin: 'auto',
    overflow: 'auto'
  },
  buttonDone: {
    width: '70px',
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    margin: '0 100px 8px 0'
  },
  tooltip: {
    margin: '5px',
    fontSize: '12px'
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#424242'
  },
  dialogActions: {
    padding: 20
  },
  csvButton: {
    color: '#FFF',
    marginTop: 3
  }
});

const ROW_PER_PAGE = 10;
const DRILLDOWN_TYPES = {
  [ADTYPE_CHART_ID]: 'adtypesdrilldown',
  [STATION_CHART_ID]: 'stationsdrilldown',
  [ADVISIT_CHART_ID]: 'creativedrilldown',
  [GEO_CHART_ID]: 'geodrilldown',
  [GA_CHART_ID]: 'webdrilldown',
  [DAYPART_COMPILATION_CHART_ID]: 'daypartdrilldown',
  [TRAFFIC_CHANNEL_CHART_ID]: 'channelsdrilldown'
};

const DEFAULT_ORDER_BY_PROPERTY = "stationLocalTime";
const DEFAULT_ORDER = "desc";

@connect(
  state => ({
    config: state.config,
    roles: state.app.roles,
    location: state.location,
    toastWithAction: state.notification.toastWithAction,
  }),
  dispatch => ({
    changeDateRange: compose(dispatch, changeDateRange),
    updateSummaryDrillDownSaga: compose(dispatch, updateSummaryDrillDownSaga),
    undoUpdateDrillDownSaga: compose(dispatch, undoUpdateDrillDownSaga),
    updateDataDrillDown: compose(dispatch, updateDataDrillDown),
    hideToastWithAction: compose(dispatch, hideToastWithAction),
    showToastWithAction: compose(dispatch, showToastWithAction),
    getDataDrillDownSaga: compose(dispatch, getDataDrillDownSaga),
    moveBackReassignSaga: compose(dispatch, moveBackReassignSaga),
    navigateDrillDownPage: (advertiserId, campaignId, tab, drilldown) => dispatch({
      type: ROUTE_DRILLDOWN,
      payload: {
        advertiserId, campaignId, tab, drilldown
      }
    }),
    navigateCampaignPage: compose(dispatch, goToCampaignPage)
  })
)
class ShowAllAds extends Component {
  state = {
    data: [],
    loading: false,
    loaded: true,
    media_id: null,
    page: 0,
    rowPerPage: ROW_PER_PAGE,
    mentionUpdates: [],
    isEditing: false,
    openShortcutModal: false,
    isResetAfterDone: false,
    updatingCSVData: false,
    reassignMentionsList: [],
    frozenExcludeList: [],
    frozenReassigList: [],
    reassignListChange: [],
    hasMentionsListChange: false,
    orderBy: DEFAULT_ORDER_BY_PROPERTY,
    order: DEFAULT_ORDER,
    isSorted: false,
    isGrouping: false,
    jobTitleMessage: "",
    isChangeCalendar: false
  };

  componentDidUpdate = prevProps=> {
    const {
      detailUrl,
      open,
      campaign,
      detailInfo,
      location,
      navigateDrillDownPage,
      id,
      currentChartId,
      onAnalyzeMention,
      navigateCampaignPage
    } = this.props;
    const {
      detailUrl: preDetailUrl,
      campaign: prevCampain = {},
      detailInfo: preDetailInfo,
      currentChartId: prevChartId,
      open: prevOpen
    } = prevProps;
    if (!detailUrl ) {
      return;
    }
    const masterCalendar = _.get(campaign, 'masterCalendar');
    const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const selected = _.get(masterCalendar, "selected");
    const start = _.get(selected, "start");
    const end = _.get(selected, "end");
    const detailStartDate = _.get(detailUrl, 'startDate', start);
    const detailEndDate = _.get(detailUrl, 'endDate', end);
    const startDate = start && convertTimezoneDate(detailStartDate, timezoneKey, true);
    const endDate = end && convertTimezoneDate(detailEndDate, timezoneKey, false);
    const hours = _.get(detailUrl, 'hours');
    const typeDrilldown = DRILLDOWN_TYPES[id];
    const pathName = _.get(location, "pathname");
    const payload = _.get(location, "payload", {});
    const {
      advertiserId: locationAdvertiserId,
      campaignId: locationCampaignId,
      tab: locationTab
    } = payload;
    if (open && !_.includes(pathName, "drilldown")) {
      navigateDrillDownPage && navigateDrillDownPage(locationAdvertiserId, locationCampaignId, locationTab, typeDrilldown);
    }
    if (!open && prevOpen) {
      navigateCampaignPage && navigateCampaignPage(locationAdvertiserId, locationCampaignId, locationTab);
    }
    const prevMasterCalendar = _.get(prevCampain, 'masterCalendar');
    const convertMasterRange = convertCalendarWithTimezone(selected, timezoneKey);
    const availableAdSources = _.get(campaign, ['availableAdSources', convertMasterRange], []);
    const { selectedAdSources } = campaign;
    const {
      campaignId,
      adType,
      creativeDuration = "",
      creativeName = "",
      stationId,
      locationId,
      geoType,
      adSources,
      usedTimezone,
      trafficIds,
      stationName
    } = detailUrl;
    let currentAdSources;
    if (!adSources) {
      currentAdSources = selectedAdSources &&
      _.isEqual([...selectedAdSources].sort(), [...availableAdSources].sort()) ? null : selectedAdSources;
    } else {
      currentAdSources = adSources;
    }

    if(JSON.stringify(masterCalendar) !== JSON.stringify(prevMasterCalendar)) {
      this.setState({
        isChangeCalendar: true
      })
    }
    const isUrlChange = (currentChartId !== prevChartId ||
      JSON.stringify(detailUrl) !== JSON.stringify(preDetailUrl) ||
      this.state.isChangeCalendar
    );
    if (isUrlChange && open) {
      const drilldownInfo = {
        adType,
        startDate,
        endDate,
        creativeDuration,
        creativeName,
        stationId,
        locationId,
        geoType,
        adSources: currentAdSources,
        hours,
        usedTimezone,
        trafficIds,
        stationName
      };
      const { getDataDrillDownSaga } = this.props;
      start && getDataDrillDownSaga(campaignId, isUrlChange, drilldownInfo);
      this.setState({
        loading: true,
        loaded: false,
        updatingCSVData: true,
        orderBy: DEFAULT_ORDER_BY_PROPERTY,
        order: DEFAULT_ORDER,
        paramGetData: {
          campaignId,
          adType,
          startDate,
          endDate,
          creativeDuration,
          creativeName,
          stationId,
          locationId,
          geoType,
          hours,
          trafficIds,
          adSources: currentAdSources
        },
        isChangeCalendar: false
      });
    }
    if(this.state.updatingCSVData && this.state.isSorted) {
      this.setState({
        updatingCSVData: false,
        isSorted: false
      })
    }
    const prevLoading = _.get(prevCampain, 'dataDrillDown.loading', false);
    if(campaign && campaign.dataDrillDown && (campaign.dataDrillDown.loading === false && prevLoading)) {
      const dataMentions = _.get(campaign, 'dataDrillDown.dataMentions', []);
      const convertingData = dataMentions.reduce((acc, mention) => {
        const datum = onAnalyzeMention ? onAnalyzeMention(mention) : mention;
        if (!datum) { return acc; } //if mention isn't available after analyzing, don't push to final list
        const newDatum = constants.KEYS.reduce((datumObject, key) => {
          let stationLocalTime = "N/A";
          if (datum && datum["daypart_datetime"]) {
            stationLocalTime = datum["daypart_datetime"];
          }
          const adsTypeId =  datum && datum["ads_type_id"];
          let adsTypeName;
          if (adsTypeId === AD_TYPE_ID["Live Reads"]) {
            adsTypeName = "Live Read";
          }
          if (adsTypeId === AD_TYPE_ID["Pre-recorded Spots"]) {
            adsTypeName = "Pre-recorded Spot";
          }
          if (adsTypeId === AD_TYPE_ID["Watchlists (Mentions)"]) {
            adsTypeName = "Watchlist (Mentions)";
          }
          return ({
            ...datumObject,
            [key]: _.get(datum, key, "N/A"),
            stationLocalTime,
            adsTypeName: adsTypeName || "N/A"
          })
        }, {} );
        acc.push({ ...datum, ...newDatum });
        return acc;
      }, []);

      this.setState({
        data: convertingData.map(mention => {
          return { ...mention }
        }),
        initialData: convertingData.map(mention => {
          return { ...mention }
        }),
        frozenDataMentions: [...campaign.dataDrillDown.frozenDataMentions],
        frozenExcludeList: [...campaign.dataDrillDown.frozenExcludeList],
        excludeMentionList: [...campaign.dataDrillDown.excludeMentionList],
        frozenReassignList: [...campaign.dataDrillDown.frozenReassignList],
        reassignMentionsList: [...campaign.dataDrillDown.reassignMentionsList],
        loading: false,
        loaded: true,
        updatingCSVData: false,
      })
    }
    const isInfoChanged = JSON.stringify(detailInfo) !== JSON.stringify(preDetailInfo);
    if (!open && isInfoChanged) {
      this.handleCloseSnackbar();
    }
  };

  componentWillUnmount = () => {
    this.unMounting = true;
  };

  handleOnClick = () => {
    this.setState({
      showAllAds: true
    });
  };

  handleClose = () => {
    this.setState({
      showAllAds: false
    });
  };

  closeShortcutsModal = () => {
    this.setState({ openShortcutModal: false });
  };

  handleOpenShortcutModal = () => {
    this.setState({ openShortcutModal: true });
  }

  handleToggleMention = (genKey, mentionStatus) => {
    this.setState(state => ({
      data: state.data.map(mention => ({
        ...mention,
        status: mention.gen_key === genKey ? mentionStatus : mention.status
      }))
    }))
  }

  setEditingCondition = () => {
    this.setState({
      isEditing: true,
    })
  }

  handleItemsExclude = (selected, status) => {
    this.setState(state => ({
      data: state.data.map(mention => {
        if (_.includes(selected, mention.gen_key)) {
          return {
            ...mention,
            status
          }
        }
        return {
          ...mention
        }
      })
    }))
  }

  handleUpdateMentions = () => {
    const { campaign, advertiser, detailUrl } = this.props;
    const {
      data,
      initialData,
      excludeMentionList,
      frozenReassignList,
      paramGetData
    } = this.state;
    let { hasMentionsListChange } = this.state;
    const excludeMentionsListChange = [];
    const includeMentionsListChange = [];
    let newExcludeMentionListId = [];
    let newIncludeMentionListId = [];

    for (let i = 0; i < data.length; i++) {
      if (data[i].status !== initialData[i].status) {
        if (data[i].status === 2) {
          newExcludeMentionListId.push(data[i].gen_key);
          excludeMentionsListChange.push(data[i]);
        }
        if(data[i].status === 1) {
          newIncludeMentionListId.push(data[i].gen_key);
          includeMentionsListChange.push(data[i])
        }
      }
    }

    let messageSnackbar = "";
    let summaryJobTitle = {};
    if ( excludeMentionsListChange.length === 0
        && includeMentionsListChange.length === 0
      ) {
          this.props.onClose();
      }
    else {
      let excludeMessage = "";
      let excludeJobTitleMessage = "";
      let includeMessage = "";
      let includeJobTitleMessage = "";
      if (excludeMentionsListChange.length) {
          excludeJobTitleMessage = excludeMentionsListChange[0].mention_name +
              (excludeMentionsListChange.length === 1 ? " has" : (" and " + (excludeMentionsListChange.length - 1) +" other have")) + " been excluded";
          excludeMessage = excludeJobTitleMessage + (detailUrl.adType ? " from " + detailUrl.adType : "");
        }
      if (includeMentionsListChange.length) {
          includeJobTitleMessage = includeMentionsListChange[0].mention_name + (includeMentionsListChange.length === 1 ? " has" : (" and " + (includeMentionsListChange.length - 1) + " other have")) + " been included";
          includeMessage = includeJobTitleMessage + (detailUrl.adType ? " from " + detailUrl.adType : "");
          includeJobTitleMessage += (excludeMentionsListChange.length) ? "\n" : "";
      }
      messageSnackbar = <span>
            {excludeMessage}
            {excludeMessage.length ? <br /> : ""}
            {includeMessage}
            {includeMessage.length ? <br /> : ""}
            Your data will refresh to reflect the update.
          </span>
      summaryJobTitle = { includeJobTitleMessage, excludeJobTitleMessage, reassignJobTitleMessage: "" };
      hasMentionsListChange = true;
      const excludeMentionsListUpdate = _.uniq([...excludeMentionList, ...newExcludeMentionListId].filter(item => !newIncludeMentionListId.includes(item)));
      this.props.updateSummaryDrillDownSaga({
        excludeMentionList: excludeMentionsListUpdate,
        reassignMentionsList: frozenReassignList,
        campaign,
        advertiser,
        summaryJobTitle,
        messageSnackbar,
        mentionsToReassign: [],
        paramGetData
      })
    }

    this.setState({
      isResetAfterDone: true,
      updatingCSVData: true,
      hasMentionsListChange,
      summaryJobTitle,
      reassignMentionsList: frozenReassignList
    })
  }

  resetAfterDone = () => {
    this.setState({ isResetAfterDone: false })
  }

  handleReassignMentions = (summaryJobTitle, reassignMentionsList) => {
    this.setState({
      summaryJobTitle,
      hasMentionsListChange: true,
      reassignMentionsList,
      updatingCSVData: true
    })
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    const {
      data,
      excludeMentionList,
      reassignMentionsList,
    } = this.state;
    const { campaign } = this.props;
    this.props.hideToastWithAction()
    this.props.updateDataDrillDown (
      data,
      data,
      excludeMentionList,
      excludeMentionList,
      reassignMentionsList,
      reassignMentionsList,
      campaign.campaign_id,
    );
  };

  handleSnackBarUndo = () => {
    const { campaign, advertiser } = this.props;
    const { frozenDataMentions, frozenExcludeList, frozenReassignList, summaryJobTitle } = this.state;

    this.props.undoUpdateDrillDownSaga(
      frozenDataMentions,
      frozenExcludeList,
      frozenReassignList,
      campaign,
      advertiser,
      summaryJobTitle
    )
    this.props.hideToastWithAction();
  }

  handleSortMention = key => event => {
    this.setState(state => ({
      orderBy: key,
      isSorted: true,
      updatingCSVData: true,
      order: key === state.orderBy && state.order === "asc" ? "desc" : "asc"
    }))
  }

  handleGrouping = status => {
    this.setState({
      isGrouping: status
    })
  }

  moveBackReassigned = (mention) => {
    const { reassignMentionsList, frozenExcludeList, paramGetData } = this.state;
    const { moveBackReassignSaga, campaign, advertiser } = this.props;
    const updateFrozenReassignList = reassignMentionsList.map(reassignMention => {
      if(reassignMention.assignTo && reassignMention.assignTo.toCreativeName === mention.mention_name
        && reassignMention.assignTo.creative_duration === mention.creative_duration) {
        return {
          ...reassignMention,
          gen_key: reassignMention.gen_key.filter(key => {
            return key !== mention.gen_key
          })
        }
      }
      return reassignMention;
    })
    const updateExcludeList = frozenExcludeList.filter(item => item !== mention.gen_key);
    const filterFrozenReassign = updateFrozenReassignList.filter(frozenReassign => {
      return frozenReassign.gen_key.length;
    });
    const summaryJobTitle = !!mention.mention_name && `${mention.mention_name} has been reassigned to Live Reads`;
    moveBackReassignSaga(campaign, advertiser, filterFrozenReassign, updateExcludeList, paramGetData, summaryJobTitle);
    this.setState({
      updatingCSVData: true
    })
  }

  render() {
    const {
      classes,
      open,
      onClose,
      detailUrl = {},
      campaign = {},
      advertiser,
      changeDateRange,
      toastWithAction,
      id,
      notifications = [],
      config,
      updateSummaryDrillDownSaga,
      roles
    } = this.props;
    const {
      data = [],
      media_id,
      openShortcutModal,
      isResetAfterDone,
      updatingCSVData,
      hasMentionsListChange,
      orderBy,
      order,
      isGrouping,
      paramGetData
    } = this.state;

    const tooltip = (
      <div className={cx(styles["custom-tooltip"])}>{"Download as CSV"}</div>
    );
    const dataForDownload = orderBy ? _.orderBy(data, orderBy, order) : data;
    const dataToDownload = dataForDownload.map(datum =>
      constants.KEYS.map(key => {
        if (key === "airtime") {
          const time = datum[key]
            ? moment(datum[key]).format("MM/DD/YY hh:mm A")
            : "N/A";
          return time;
        }
        if(key === "status") {
          const value = datum[key];
          if(value === EXCLUDE) {
             return "TRUE"
          }
          if(value === INCLUDE || value === REASSIGN) {
            return "FALSE"
          }
        }
        if(key === "status_reassign") {
          return datum[key] === REASSIGNED ? "TRUE" : "FALSE";
        }
        return datum[key];
      })
    );
    const isReassigned = detailUrl.adType && detailUrl.adType === 'Live Reads';
    const headerInCsv = id === ADTYPE_CHART_ID && isReassigned
      ? constants.HEADER_SHOW_ALL_ADS.filter(headerKey => {
          return headerKey !== "Reassigned";
        })
      : constants.HEADER_SHOW_ALL_ADS;
    if (dataToDownload) {
      dataToDownload.forEach(data => {
        data.splice(headerInCsv.length);
      });
    }
    const csvData = [headerInCsv, ...dataToDownload];
    const fileName = _.get(campaign, "campaign_name", "campaign_default");
    const sortedMentionData = orderBy ? _.orderBy(data, orderBy, order) : data;
    const summaryLoading = _.get(campaign, "dataDrillDown.loading");
    const summaryLoaded = _.get(campaign, "dataDrillDown.loaded");
    return (
      <Dialog
        onClose={onClose}
        open={open}
        disableEnforceFocus
        className={classes.dialogShowAllAds}
        fullScreen
      >
        <DialogTitle className={cx(classes.dialogTitle, styles["dialog-title"])} disableTypography>
          <span className={cx(styles["title"])}>{detailUrl.adType}</span>
          <div className={classes.dialogTitle}>
            {/* <Notifier notifications={notifications} /> */}
            {!updatingCSVData && summaryLoaded && (
              <Tooltip title={tooltip} placement="bottom">
                <CSVLink
                  data={csvData}
                  filename={`${fileName}.csv`}
                  target="_blank"
                >
                  <Button className={classes.csvButton}>
                    <GetAppIcon />
                  </Button>
                </CSVLink>
              </Tooltip>
            )}
            <Tooltip
            title={
              <div className={styles["custom-tooltip"]}>
                Keyboard Shortcuts
              </div>
            }
            placement="bottom"
            disableFocusListener
            >
              <Button>
                <Keyboard onClick={this.handleOpenShortcutModal} />
              </Button>
            </Tooltip>
            <div className={cx(styles["divide"])} />
            <Button onClick={onClose}>
              <Close />
            </Button>
          </div>
          <KeyboardShortcutsModal
            open={openShortcutModal}
            onClose={this.closeShortcutsModal}
          />
        </DialogTitle>
        <DialogContent className={!isGrouping ? classes.dialogContent : ''}>
          {summaryLoading && <span>Loading ... </span>}
          {summaryLoaded &&
            (data.length === 0 ? (
              <span>No ads available</span>
            ) : (
                <SummaryDrillDown
                  campaign={campaign}
                  advertiser={advertiser}
                  mentions={sortedMentionData}
                  headerMaps={constants.HEAD_MAPS_LIVEREAD}
                  media_id={media_id}
                  handleToggleMention={this.handleToggleMention}
                  changeDateRange={changeDateRange}
                  setEditingCondition={this.setEditingCondition}
                  handleItemsExclude={this.handleItemsExclude}
                  isResetAfterDone={isResetAfterDone}
                  resetAfterDone={this.resetAfterDone}
                  detailUrl={detailUrl}
                  handleReassignMentions={this.handleReassignMentions}
                  handleSortMention={this.handleSortMention}
                  orderBy={orderBy}
                  order={order}
                  handleGrouping={this.handleGrouping}
                  id={id}
                  config={config}
                  updateSummaryDrillDownSaga={updateSummaryDrillDownSaga}
                  paramGetData={paramGetData}
                  moveBackReassigned={this.moveBackReassigned}
                  roles={roles}
                  />
              ))}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          {
           summaryLoaded &&
            <Button onClick={this.handleUpdateMentions} color="primary" variant="contained" className={classes.buttonDone} data-test="drillDownDoneBtn">
              Done
            </Button>
          }
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={toastWithAction.open && toastWithAction.toastAction === SHOW_TOAST_ACTIONS.SUMMARY_DRILL_DOWN}
            autoHideDuration={6000}
            onClose={this.handleCloseSnackbar}
            className={styles["summary-snackbar"]}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<div id="message-id">{toastWithAction.message}</div>}
            action={
              hasMentionsListChange ?
              [
              <Button key="undo" size="small" className={styles["undo-button"]} onClick={this.handleSnackBarUndo}>
                UNDO
              </Button>,
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon />
              </IconButton>,
            ]
            :
            [
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon />
              </IconButton>
            ]
          }
          />
        </DialogActions>
      </Dialog>
    );
  }
}

ShowAllAds.propTypes = {
  classes: objectOf(string),
  open: bool,
  onClose: func,
  detailUrl: detailUrlPropsType,
  detailInfo: detailUrlPropsType,
  campaign: shape({
    chartData: object,
    campaign_id: number
  }),
  getDataDrillDownSaga: func,
  updateSummaryDrillDownSaga: func,
  hideToastWithAction: func,
  updateDataDrillDown: func,
  undoUpdateDrillDownSaga: func,
  changeDateRange: func,
  toastWithAction: shape({
    open: bool
  }),
  advertiser: advertiserShape,
  id: number,
  currentChartId: number,
  notifications: arrayOf(shape({
    id: oneOfType([string, number])
  })),
  moveBackReassignSaga: func,
  config: shape({
    urlApi: shape(objectOf(string))
  }),
  roles: arrayOf(objectOf(string)),
  navigateDrillDownPage: func,
  location: shape({
    pathname: string,
    payload: {
      advertiserId: number,
      campaignId: number,
      tab: string
    }
  }),
  onAnalyzeMention: func,
  navigateCampaignPage: func
};

export default withStyles(customStyle)(ShowAllAds);
